<template>
  <div class="final-confirm-box">
    <user-header></user-header>
    <user-menu :status='1'></user-menu>
    <div class="send-edit-main-box">

      <h3 class="send-edit-box-title">ご注文内容の最終確認</h3>

      <div class="send-box">
        <div class="confirm-box">
          <h4>商品内容</h4>
          <div class="cart-item" v-for="(cart, index) in carts" :key="index">

            <div class="flex">
              <div class="item-box">
                <p class="item-box-title">茶葉</p>
                <p class="" v-for="(item, index2) in cart.item" :key="index2">・{{items_id_list[item].name}}</p>
              </div>
              <div class="item-box2">
                <p class="item-box-title">焙煎</p>
                <p>{{roasted_text(cart.roasted)}}</p>
              </div>
              <div class="item-box3">
                <p class="item-box-title">内容量 / 個数</p>
                <p>{{cart.weight}}g × {{cart.num}}個</p>
              </div>
              <div class="item-box4">
                <p class="item-box-title">価格(税抜)</p>
                <p>{{yen(cart.price)}}円</p>
              </div>
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="confirm-box price-box">
            <h4>お支払い金額</h4>
            <div class="price-sub">
              <p class="price-about">商品合計：<label>{{total[0]}}円</label></p>
              <p class="price-about">税：<label>{{total[1]}}円</label></p>
              <p class="price-about">送料：<label>{{total[2]}}円</label></p>
            </div>
            <p class="total_price">合計：<label>{{total[3]}}円</label></p>
          </div>

          <div class="confirm-box address-box">
            <h4>お届け先</h4>
            {{send_address.name}}<br />
            〒{{send_address.zip_code}}
            {{send_address.prefecture}}<br />
            {{send_address.address1}}
            {{send_address.address2}}
          </div>
        </div>

        <div class="warning">
          <p>入力前に必ずご確認ください。</p>
          <span>カード情報を入力し、購入ボタンを押しますと、その時点で決済が完了します。<br />購入内容等の確認画面はありませんのでご注意ください。<br />また、決済完了後のお客様都合のキャンセルはできませんので、あらかじめご了承ください。</span>
        </div>

      </div>

      <div class="btn-box">
        <button class="button back" @click="back()">戻る</button>
        <button class="button buy" @click="buy()">カード情報を入力</button>
        <!-- <div id="apple-pay-button" class="apple-pay-button apple-pay-button-black"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'FinalConfirm',
  head: {
    script: function () {
      return [
        {
          type: 'text/javascript',
          src: 'https://checkout.pay.jp/',
          class:"payjp-button",
          'data-key':this.$DF.DATA_KEY,
          'data-on-created':"onCreated",
          'data-submit-text':"購入",
          'data-partial':"true",
          'data-payjp-three-d-secure':"true",
          'data-payjp-three-d-secure-workflow':"subwindow",
          'data-payjp-extra-attribute-email':"",
          'data-payjp-extra-attribute-phone':"",
          'data-payjp-partial':"true",
          body: true
        },
      ];
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      carts: this.$store.getters['uCart/carts'],
      send_address: this.$store.getters['uCart/send_address'],
      items_id_list: this.$store.getters['uItemList/items_id_list'],
      roasteds: this.$store.getters['uItemList/roasteds'],
      total: this.$store.getters['uCart/total_price'],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    // window.apple_pay_init();
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    buy () {
      window.onCreated_cb_set(this.buy_cb);
      const tag = this.$lib._$id('payjp_checkout_box');
      const evt = document.createEvent("MouseEvents");
      evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      tag.children[0].dispatchEvent( evt );
    },
    buy_cb (res) {
      if (res.error) {
        this.$alert('alert', 'カード情報に謝りがあります。\n再度入力してください。');
        return;
      }

      let ld = new this.$loader(this);
      ld._data_set({
        'card_token': res.id,
        'orders': this.$store.getters['uCart/carts'],
        'post_price': this.total[2],
        'tax': this.total[1],
        'send_address': this.send_address,
      });
      ld._post_cb_f = this.pay_check_cb;
      ld._load_start('/user/pay_check.php');
    },
    pay_check_cb (data) {
      // カートをリセット
      this.$store.commit('uCart/reset');

      this.$router.push({name: 'uPayFin', query: {'order_id': data.data.order_id}});
    },
    yen (p) {
      return this.$lib._yen(p);
    },
    roasted_text (n) {
      const obj = this.roasteds.filter(function (item){
        if (item.id === n) return true;
      });
      return obj[0].roasted;
    },
    back () {
      this.$router.push({name: 'uSendEdit', query: {}});
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.final-confirm-box {
  .send-edit-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
    h4 {
      margin-bottom: 10px;
    }
    .send-edit-box-title{
      font-size: 22px;
      text-align: center;
      border-bottom: 4px solid #d4ff9d;
      padding: 0px 10px;
      margin: 0;
    }
    .send-box {
      width: 660px;
      margin: 30px auto 0 auto;
      text-align: left;

    }
    .confirm-box {
      margin-top: 10px;
      padding: 20px;
      background: #f7f7f7;
    }
    .address-box {
    }
    .button {
      margin: 0px 20px 20px 20px;
      padding: 13px 10px 15px 10px;
      width: 36%;
      border: none;
      border-radius: 6px;
      color: #fefefe;
      font-size: 16px;
      cursor: pointer;
    }
    .address-list {
      margin-top: 10px;
      .address {
        display: inline-block;
        padding: 0 0 0 25px;
      }
    }
    .btn-box {
      margin-top: 50px;
      .back {
        width: 100px;
      }
    }
    .cart-item {
      border-bottom: 1px dashed #cccccc;
      margin-bottom: 10px;
    }
    .cart-item:last-child {
      border-bottom: none;
      margin-bottom: 0px;
    }
    .item-box-title {
      font-size: 14px;
      font-weight: 600;
      background-color: #d4ff9d;
      padding: 3px;
    }
    .flex {
      display: flex;
      flex-wrap: wrap;
    }
    .item-box {
      width: 180px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box2 {
      width: 180px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box3 {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .item-box4 {
      width: 80px;
    }
    .price-about {
      text-align: right;
      font-size: 16px;
      margin-right: 20px;
      label {
        width: 80px;
        display: inline-block;
      }
    }
    .address-box {
      flex: 1;
      margin-left: 10px;
    }
    .total_price {
      width: calc(100% - 40px);
      text-align: right;
      font-size: 24px;
      margin: 5px 20px;
      font-weight: 600;
      border-bottom: 1px solid #666666;
      label {
        color: #a91b18;
      }
    }
    .warning {
      margin-top: 20px;
      border: 8px solid #cecbc4;
      background: #f3f4f1;
      border-radius: 8px;
      text-align: center;
      padding: 20px;
      p {
        color: #df274c;
        font-weight: 800;
        margin-bottom: 10px;
      }
      span {
        font-size: 13px;
        line-height: 1.3;
        display: inline-block;
      }

    }
  }

  // @supports (-webkit-appearance: -apple-pay-button) {
  //     .apple-pay-button {
  //         display: inline-block;
  //         -webkit-appearance: -apple-pay-button;
  //     }
  //     .apple-pay-button-black {
  //         -apple-pay-button-style: black;
  //     }
  // }
  // @supports not (-webkit-appearance: -apple-pay-button) {
  //     .apple-pay-button {
  //         display: inline-block;
  //         background-size: 100% 60%;
  //         background-repeat: no-repeat;
  //         background-position: 50% 50%;
  //         border-radius: 5px;
  //         padding: 0px;
  //         box-sizing: border-box;
  //         min-width: 200px;
  //         min-height: 32px;
  //         max-height: 64px;
  //     }
  //     .apple-pay-button-black {
  //         background-image: -webkit-named-image(apple-pay-logo-white);
  //         background-color: black;
  //     }
  // }

  @media (max-width: 767px) {
    .send-edit-main-box {
      padding: 20px;
      margin: 50px 0 0 0;
      height: calc(100vh - 90px);
      .send-box {
        width: 100%;
      }
      .address-box {
        width: 100%;
        margin-left: 0px;
      }
      .price-box {
        width: 100%;
      }
      .button {
        width: 50%;
        margin: 0px 10px 20px 10px;
      }
    }
  }
}
</style>
